import { showSpinner, hideSpinner } from "./helperServices";
import { getGeographicSiteStockService } from "../services/checkoutService";

export default (geoLocation, sku, populateStoreList, serviceDown) => {
	const clientType = 'CBU';
	const deviceId = '0'; // anything
	const latitude = geoLocation?.latitude; //-25.968857;
	const longitude = geoLocation?.longitude; //28.128515;
	const stockCode = sku; //'103004940'; // SKU
	const storeTypes = ["Chatz", "Vodacom4u", "RepairCentre", "Vodacom Approved Dealer", "Vodacom Express", "Vodacom Shop"];

	try {
		showSpinner();
		getGeographicSiteStockService(clientType, deviceId, latitude, longitude, stockCode, storeTypes.join(',')).then(results => {
			hideSpinner();
			if (!results.fail) {
				let sortedLists = results?.response?.data?.result?.result?.storeList;

				sortedLists = sortedLists.sort(function (a, b) {
					if (a.distance < b.distance) { return -1; }
					if (a.distance > b.distance) { return 1; }
					return 0;
				})
				populateStoreList(sortedLists);
				serviceDown(sortedLists.length > 0 ? false : true);
			} else if (results.fail) {
				serviceDown(true);
			}
		}, (_err) => {
			hideSpinner();
		})
	} catch (e) {
		hideSpinner();
		serviceDown(true);
	}
};